import React, { useEffect } from "react";
import { Modal, Button, Table } from "react-bootstrap";

const InfoModal = ({ show, handleClose, vendor }) => {
    useEffect(() => {
        // This will ensure that the Esc key works to close the modal
        const handleEscKey = (event) => {
            if (event.key === "Escape") {
                handleClose();
            }
        };

        document.addEventListener("keydown", handleEscKey);

        // Clean up the event listener on component unmount
        return () => {
            document.removeEventListener("keydown", handleEscKey);
        };
    }, [handleClose]);

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            centered
            backdrop="static"
            keyboard={true}  // Allows closing the modal with the Esc key
            style={{ zIndex: 1051 }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Vendor Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {vendor ? (
                    <Table bordered striped responsive>
                        <tbody>
                            <tr>
                                <td style={{ width: "40%", fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Vendor Name:</td>
                                <td>{vendor.FirstName} {vendor.LastName}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Company Name:</td>
                                <td>{vendor.CompanyName}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Source:</td>
                                <td>{vendor.SourceName}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Category:</td>
                                <td>{vendor.CategoryName}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Country:</td>
                                <td>{vendor.Country}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Contact:</td>
                                <td>{vendor.Contact}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Email:</td>
                                <td>{vendor.Email}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Website:</td>
                                <td>{vendor.Website}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Comments:</td>
                                <td>{vendor.Comments}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Priority:</td>
                                <td>{vendor.Priority}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Export Countries:</td>
                                <td>{vendor.ExportCountries}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Status:</td>
                                <td>{vendor.Status}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Communication Mode:</td>
                                <td>{vendor.CommunicationMode}</td>
                            </tr>
                            <tr>
                                <td style={{ fontWeight: "bold", textAlign: "right", paddingRight: "10px" }}>Date:</td>
                                <td>{new Date(vendor.Date).toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </Table>
                ) : (
                    <p>No details available.</p>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InfoModal;
